import styled from 'styled-components';

export const $ReferenceListPopover = styled.div`
  font-family: ${props => props.theme.fontFamily};
  background-color: white;
  font-size: ${props => props.theme.fontSize}px;
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: ${props => props.theme.borderRadius}px;
  display: flex;
  flex-direction: column;
  padding: 4px;
`;

export const $ReferenceListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 8px;
  line-height: 22px;
  height: 28px;
  border-radius: ${props => props.theme.borderRadius}px;

  &.selected {
    background-color: ${props => props.theme.colorBgLayout};
    color: ${props => props.theme.colorPrimary};
  }
`;
